import React from 'react'
import CV from '../../images/cv.pdf'
import './resume.css'

const Resume = () => {
    return (
        <div className='resume__container'>
            <h3>Resume Preview</h3>
            <iframe
                src={CV}
                title="Resume"
                className='resume__viewer'
            />
        </div>
    )
}

export default Resume

